import React, { memo, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom'
import OptimizedImage from '../OptimizedImage';
import { ConfigurableImage, ConfigurableContainer } from '../ConfigurableElement';
import { useUIConfig } from '../../hooks/useUIConfig';
import { useAuth } from '../../hooks/useAuth';
import { useSubscription } from '../../hooks/useSubscription';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import himg from '../../images/slider/right-img.png'
import rightImgAvif480 from '../../images/slider/right-img-480.avif'
import rightImgWebp480 from '../../images/slider/right-img-480.webp'
import airplaneImg from '../../images/children/airplane.png'
import anasBotImg from '../../images/children/anas_bot.png'
import { Helmet } from 'react-helmet-async';
import './style.css';

// Hero component with identical layout for both English and Arabic versions
// Translation will be implemented gradually while maintaining the same visual structure
const Hero = memo(() => {
    const { t } = useTranslation();
    const { applyCSS } = useUIConfig();
    const { isAuthenticated } = useAuth();
    const { hasActiveSubscription, isDemoSubscription } = useSubscription();
    const navigate = useNavigate();

    // Apply CSS when component mounts
    useEffect(() => {
        applyCSS();
    }, [applyCSS]);

    return (
        <section className="wpo-hero-section-1">
            <Helmet>
                <title>{t('hero.title')}</title>
                <meta name="description" content={t('hero.description')} />
            </Helmet>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-6 col-lg-6">
                        <div className="wpo-hero-section-text">
                            <div className="wpo-hero-title">
                                <h2>
                                    <span>{t('hero.learn')}</span>
                                    <span>{t('hero.arabic')}</span>
                                    <span>{t('hero.today')}</span>
                                </h2>
                            </div>
                            <div className="btns">
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (!isAuthenticated) {
                                            navigate('/signup', { state: { action: 'demo' } });
                                        } else if (hasActiveSubscription && !isDemoSubscription) {
                                            toast.info(t('hero.alreadySubscribed'));
                                            navigate('/dashboard');
                                        } else if (isDemoSubscription) {
                                            toast.info(t('hero.alreadyDemo'));
                                            navigate('/dashboard');
                                        } else {
                                            navigate('/demo-confirmation');
                                        }
                                    }}
                                    className="btn-large"
                                >
                                    {t('hero.accessFreeDemo')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Airplane image positioned between right column and left title */}
            <ConfigurableContainer
                section="hero"
                element="airplane"
                className="airplane-container"
            >
                <img src={airplaneImg} alt={t('hero.airplaneAlt')} className="airplane-img" />
            </ConfigurableContainer>

            {/* Anas Bot image positioned to the left of the title */}
            <div className="anas-bot-container">
                <img src={anasBotImg} alt={t('hero.anasBotAlt')} className="anas-bot-img" />
            </div>
            <div className="right-vec">
                <div className="right-img">
                    <OptimizedImage
                        src={himg}
                        alt={t('hero.learningPlatformAlt')}
                        fetchpriority="high"
                        loading="eager"
                        decoding="async"
                        avifSrcSet={`${rightImgAvif480} 480w`}
                        webpSrcSet={`${rightImgWebp480} 480w`}
                        sizes="(max-width: 768px) 90vw, 600px"
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />
                </div>
                <div className="round-1"></div>
                <div className="round-2"></div>
                <div className="round-3"></div>
                <div className="round-4"></div>
            </div>

            <div className="social-link">
                <ul>
                    <li><a href="https://www.facebook.com/anas.ar.learning" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                    <li><a href="https://www.youtube.com/@Learningarabic.online" target="_blank" rel="noopener noreferrer">Youtube</a></li>
                    <li><a href="https://www.instagram.com/anas.learn.arabic" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                </ul>
            </div>
        </section>
    )
});

export default Hero;